import { useState } from 'react';

const useForm = (callback, validate) => {

  const [values, setValues] = useState({});
  const [errors, setErrors] = useState({});

  const handleSubmit = (event) => {
    if (event) event.preventDefault();
    const validationErrors = validate(values);
    setErrors(validationErrors);
    
    // Only submit if validation passes
    if (Object.keys(validationErrors).length === 0) {
      try {
        callback();
      } catch (error) {
        console.error('Form submission callback error:', error);
        // Callback should handle its own errors, but catch to prevent crash
      }
    }
  };

  const handleChange = (event) => {
    event.persist();
    setValues(values => ({ ...values, [event.target.name]: event.target.value }));
  };

  const resetForm = () => {
    setValues({});
    setErrors({});
  }

  return {
    values,
    errors,
    handleChange,
    handleSubmit,
    resetForm
  }
};

export default useForm;

// https://upmostly.com/tutorials/form-validation-using-custom-react-hooks